import { IconButton } from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useAppDispatch } from '@reduxStore';
import { queueModal } from '@components/Modals/modalSlice';

import styles from '../DataGrid.Dispatch.module.css';

export default function CreateOrder() {
	const appDispatch = useAppDispatch();

	const handleClick = () => {
		appDispatch(
			queueModal({
				Component: 'addConsignment'
			})
		);
	};

	return (
		<IconButton
			title='Create New Order'
			onClick={handleClick}
			className={`${styles['icon-btn']} ${styles['create-order-btn']}`}
		>
			<AddTwoToneIcon />
		</IconButton>
	);
}
